import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import ReplaceableText from '../../../../utils/text/ReplaceableText/index';

const IconList = ({ rendering, fields }) => {
  return (
    <div className="vds-icon-listing">
      <div className="vds-icon-listing__inner">
        {fields?.title?.value && <ReplaceableText tag="strong" field={fields.title} />}
        <ul className="vds-icon-listing__list">
          <Placeholder name="iconlist-items" rendering={rendering} />
        </ul>
      </div>
    </div>
  );
};

export default IconList;
